import { IAddress } from '../../../interfaces/address';
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import styles from './index.module.scss';
import { DELIVERY_OPTIONS } from '../../../utils/constant';
import LocationDetails from './locationDetails';
import AddressDetails from './addressDetails';
import SearchLocation from './searchLocation';
import { LocationPickerWrapper } from '../LocationPickerWrapper';
import { getSanitizedLocationCoordsForAddress } from 'utils';

export const addressComponents = {
  locationDetails: 'locationDetails',
  addressDetails: 'addressDetails',
  searchLocation: 'searchLocation',
};

export const getEmptyAddress = (): IAddress.IAddressItem => {
  return {
    selected: false,
    objectId: '',
    address: '',
    town: '',
    coords: null,
    number: '',
    zip: '',
    default: false,
    contactName: '',
    contactPhone: '',
  };
};

const defaultLocation = {
  lat: 18.2208,
  lng: -66.5901,
};

const defaultAddress = {
  selected: false,
  address: 'Puerto Rico',
  secondAddress: '',
  contactName: '',
  contactPhone: '',
  default: false,
  objectId: '',
  town: '',
  zip: '',
  number: '',
  coords: defaultLocation,
  deliveryOption: DELIVERY_OPTIONS[0],
};
const AddAddressModal: React.FC<IAddress.IAddAddressModalProps> = (props) => {
  const {
    modalOpen,
    onModalClose,
    user,
    address = defaultAddress,
    onSuccess = () => {},
  } = props;
  const [componentToShow, setComponentToShow] = useState(
    addressComponents.locationDetails,
  );
  const [localAddress, setLocalAddress] = useState<IAddress.IAddressItem>(address);

  useEffect(() => {
    if (Object.keys(address)?.length) {
      setLocalAddress({ ...address, coords: getSanitizedLocationCoordsForAddress(address?.coords) });
    } else {
      setLocalAddress(defaultAddress);
    }
  }, [address]);

  const setAddressKey = (values) => {
    setLocalAddress({ ...localAddress, ...values });
  };

  const handleClose = () => {
    onModalClose();
    setComponentToShow(addressComponents.locationDetails);
  };

  const renderLocationSearch = () => {
    if(componentToShow === addressComponents.searchLocation){
      return <SearchLocation
        setComponentToShow={setComponentToShow}
        onSelect={(e) => {
          setComponentToShow(addressComponents.locationDetails);
          setLocalAddress({
            ...localAddress,
            coords: e.coords,
            address: e.address,
          });
        }}
      />;
    } else {
      return null;
    }
  };

  const renderAddressDetails = () => {
    if(componentToShow === addressComponents.addressDetails){
      return (
        <AddressDetails
          setComponentToShow={setComponentToShow}
          localAddress={localAddress}
          setAddressKey={setAddressKey}
          handleClose={handleClose}
          user={user}
          onSuccess={onSuccess}
        />
      );
    } else {
      return null;
    }
  };

  return (
    <Modal show={modalOpen} animation={false} size='lg'>
      <LocationPickerWrapper
        containerStyle={
          componentToShow === addressComponents.addressDetails
            ? containerStyleAddressDetails
            : containerStyle
        }
        locationCoords={localAddress.coords}
        isVisible={componentToShow !== addressComponents.searchLocation}
        draggable={componentToShow === addressComponents.locationDetails}
      />
      <Modal.Body>
        <div>
          <div className={`${styles['edit-address']} row`}>
            <LocationDetails
              locationCoords={localAddress.coords}
              setComponentToShow={setComponentToShow}
              localAddress={localAddress}
              handleClose={handleClose}
              setLocalAddress={setLocalAddress}
              isVisible={componentToShow === addressComponents.locationDetails}
            />
            {renderLocationSearch()}
            {renderAddressDetails()}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const containerStyle = {
  position: 'relative',
  width: '100%',
  height: '300px',
  borderRadius: '10px',
};

const containerStyleAddressDetails = {
  position: 'relative',
  width: '100%',
  height: '200px',
  borderRadius: '2px',
};
export default AddAddressModal;
